import { appRouteTemplate } from '../routes/templates.ts';
import { useStore } from '../api/index.ts';
import {
  type RouteLocationNormalizedGeneric,
  type RouteLocationNormalizedLoadedGeneric,
  type NavigationGuardNext,
} from 'vue-router';
import { setHTMLDarkMode } from '../assets/js/helpers/DarkThemeHelper.ts';


export const appRoutes = [
  {
    path: '/app',
    redirect: '/app/dashboard',
    meta: {
      authRequired: true,
    },
  },
  appRouteTemplate({
    path: '/app/dashboard',
    component: () => import('../views/app/DashboardView.vue'),
    name: 'Dashboard',
    title: 'Dashboard',
  }),
  appRouteTemplate({
    path: '/app/settings',
    component: () => import('../views/app/SettingsView.vue'),
    name: 'Settings',
    title: 'Settings',
  }),
  appRouteTemplate({
    path: '/app/search',
    component: () => import('../views/app/SearchView.vue'),
    name: 'Search Results',
    title: 'Search',
  }),
  appRouteTemplate({
    path: '/app/settings/billing',
    component: () => import('../views/app/LoadingView.vue'),
    name: 'Billing',
    title: 'Billing',
  }),
  appRouteTemplate({
    path: '/app/racks',
    name: 'Racks',
    component: () => import('../views/app/RackView.vue'),
    title: 'Racks',
  }),
  appRouteTemplate({
    path: '/app/racks/compare',
    name: 'Compare Racks',
    component: () => import('../views/app/RackCompareView.vue'),
    title: 'Compare Racks',
  }),
  {
    path: '/app/racks/:id',
    component: () => import('../views/app/RackManageView.vue'),
    meta: {
      authRequired: true,
      layout: 'AppLayout',
    },
    beforeEnter(
      to: RouteLocationNormalizedGeneric,
      from: RouteLocationNormalizedLoadedGeneric,
      next: NavigationGuardNext,
    ) {
      next({
        path: '/app/racks/' + to.params.id + '/edit',
      });
    },
  },
  {
    path: '/app/racks/:id/edit',
    name: 'Manage Rack',
    component: () => import('../views/app/RackManageView.vue'),
    meta: {
      authRequired: true,
      layout: 'AppLayout',
      title: 'Edit Rack',
    },
    beforeEnter(
      to: RouteLocationNormalizedGeneric,
      from: RouteLocationNormalizedLoadedGeneric,
      next: NavigationGuardNext,
    ) {
      const store = useStore();
      setHTMLDarkMode(store.userPreferences.darkMode);
      if (store.teamData && store.userMode == 'team' && store.teamData.role == 'viewer') {
        next({
          path: '/app/racks/' + to.params.id + '/view',
        });
      } else {
        next();
      }
    },
  },
  appRouteTemplate({
    path: '/app/racks/:id/view',
    name: 'View Rack',
    component: () => import('../views/app/RackReadView.vue'),
    title: 'View Rack',
  }),
  appRouteTemplate({
    path: '/app/rooms',
    name: 'Rooms',
    component: () => import('../views/app/RoomView.vue'),
    title: 'Rooms',
  }),
  {
    path: '/app/rooms/:id',
    component: () => import('../views/app/RoomManageView.vue'),
    meta: {
      authRequired: true,
      layout: 'AppLayout',
    },
    beforeEnter(
      to: RouteLocationNormalizedGeneric,
      from: RouteLocationNormalizedLoadedGeneric,
      next: NavigationGuardNext,
    ) {
      next({
        path: '/app/rooms/' + to.params.id + '/edit',
      });
    },
  },
  {
    path: '/app/rooms/:id/edit',
    name: 'Manage Room',
    component: () => import('../views/app/RoomManageView.vue'),
    meta: {
      authRequired: true,
      layout: 'AppLayout',
      title: 'Edit Room',
    },
    beforeEnter(
      to: RouteLocationNormalizedGeneric,
      from: RouteLocationNormalizedLoadedGeneric,
      next: NavigationGuardNext,
    ) {
      const store = useStore();
      setHTMLDarkMode(store.userPreferences.darkMode);
      if (store.teamData && store.userMode == 'team' && store.teamData.role == 'viewer') {
        next({
          path: '/app/rooms/' + to.params.id + '/view',
        });
      } else {
        next();
      }
    },
  },
  appRouteTemplate({
    path: '/app/rooms/:id/view',
    name: 'View Room',
    component: () => import('../views/app/RoomReadView.vue'),
    title: 'View Room',
  }),
  appRouteTemplate({
    path: '/app/types',
    name: 'Types',
    component: () => import('../views/app/TypeView.vue'),
    title: 'Slot Types',
  }),
  appRouteTemplate({
    path: '/app/inventory',
    name: 'Inventory',
    component: () => import('../views/app/InventoryView.vue'),
    title: 'Inventory',
  }),
  appRouteTemplate({
    path: '/app/sso',
    component: () => import('../views/SSORequiredView.vue'),
    name: 'Single Sign-On',
    title: 'SSO Required',
  }),
];
